namespace Portico.Directives {
    import Inject = Portico.Decorators.Inject;
	import ps = Portico.Services;

    export interface ITcTriplePhoneController extends angular.IController {
        _area: string;
        _prefix: string;
        _line: string;

		change: () => void;
        disabled: string;
        inputClass: string;
        key: string;
        mask: string;
        pattern: string;
        placeholder: string;
        readonly: string;
        required: string;

        tcForm: ITcFormController;
		id: string;

		isDisabled: () => boolean;
		//onChange: () => void;
    }

    @Inject('$scope')
    export class TcTriplePhoneController implements ITcTriplePhoneController {
        _area: string;
        _prefix: string;
        _line: string;

		change: () => void;
        disabled: string;
        inputClass: string;
        key: string;
        mask: string;
        pattern: string;
        placeholder: string;
        readonly: string;
        required: string;

        tcForm: ITcFormController;
		id: string;

        constructor(
            private $scope: angular.IScope
        ) {
        }

        get area() {
            return this._area;
        }

        set area(value: string) {
            this._area = value;
            this.full = (this._area ? this._area : '') + (this._prefix ? this._prefix : '') + (this._line ? this._line : '');

            if (this._area.length === 3) {
                $('#' + this.id + '-input-prefix').focus().select();
            }
        }

        get prefix() {
            return this._prefix;
        }

        set prefix(value: string) {
            this._prefix = value;
            this.full = (this._area ? this._area : '') + (this._prefix ? this._prefix : '') + (this._line ? this._line : '');

            if (this._prefix.length === 3) {
                $('#' + this.id + '-input-line').focus().select();
            }
        }

        get line() {
            return this._line;
        }

        set line(value: string) {
            this._line = value;
            this.full = (this._area ? this._area : '') + (this._prefix ? this._prefix : '') + (this._line ? this._line : '');
        }

        get full() {
            return this.$scope.$eval(`${this.key}`);
        }

        set full(value: string) {
            this.$scope.$eval(`${this.key}='${value}'`);

			if (this.tcForm.ngForm[`${this.id}_area`].$dirty || this.tcForm.ngForm[`${this.id}_prefix`].$dirty || this.tcForm.ngForm[`${this.id}_line`].$dirty) {
				this.tcForm.ngForm[`${this.id}`].$setDirty();

				if (this.change) {
					this.change();
				}
			}
        }

		isDisabled(): boolean {
			return this.disabled === 'true' || (this.tcForm && this.tcForm.isDisabled());
		}

		//onChange(): void {
		//	if (this.change) {
		//		this.change();
		//	}
		//}
    }

    angular.module('app')
        .directive('tcTriplePhone', [
			'$compile',
			'$stateParams',
			'dataService', (
				$compile: angular.ICompileService,
				$stateParams: angular.ui.IStateParamsService,
				dataService: ps.IDataService) => {
				return {
					bindToController: {
						change: '&?',
						disabled: '@',
						inputClass: '@',
						key: '@',
						mask: '@',
						pattern: '@',
						placeholder: '@',
						readonly: '@',
						required: '@'
					},
					controller: <any>TcTriplePhoneController,
					controllerAs: '$phone',
					link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
						const tcTriplePhone: ITcTriplePhoneController = $ctrl[0];
						const tcForm: ITcFormController = $ctrl[1];

						if (tcForm) {
							tcTriplePhone.tcForm = tcForm;
							//$ctrl[1].tcInputs.push(tcTriplePhone);
						}

						const key: string = tcTriplePhone.key ? tcTriplePhone.key : null;

						tcTriplePhone.id = key.replace(/[\.\'\$\[\]\(\)]+/g, '_');

						const inputClass = tcTriplePhone.inputClass ? ' ' + tcTriplePhone.inputClass : '';
						const pattern = tcTriplePhone.pattern ? tcTriplePhone.pattern : '/^\\d{10}$/';
						let inputAttrs = ['', '', '', ''];

						const full: string = $scope.$eval(`${key}`);

						if (full && full.length === 10) {
							tcTriplePhone._area = full.substr(0, 3);
							tcTriplePhone._prefix = full.substr(3, 3);
							tcTriplePhone._line = full.substr(6, 4);
						}

						if (tcTriplePhone.disabled) {
							inputAttrs[1] += `disabled="${tcTriplePhone.disabled}" `;
							inputAttrs[2] += `disabled="${tcTriplePhone.disabled}" `;
							inputAttrs[3] += `disabled="${tcTriplePhone.disabled}" `;
						}

						if (tcTriplePhone.mask) {
							inputAttrs[1] += `ui-mask="999" ui-mask-placeholder ui-mask-placeholder-char="_" ui-options="{ clearOnBlur: false }"`;
							inputAttrs[2] += `ui-mask="999" ui-mask-placeholder ui-mask-placeholder-char="_" ui-options="{ clearOnBlur: false }"`;
							inputAttrs[3] += `ui-mask="9999" ui-mask-placeholder ui-mask-placeholder-char="_" ui-options="{ clearOnBlur: false }"`;
						}

						if (tcTriplePhone.placeholder) {
							inputAttrs[1] += `placeholder="888"`;
							inputAttrs[2] += `placeholder="888"`;
							inputAttrs[3] += `placeholder="8888"`;
						}

						if (tcTriplePhone.required) {
							if (dataService.session.mode !== 'edit' && dataService.session.mode !== 'mock') {
								inputAttrs[0] += `required="${tcTriplePhone.required}"`;
								inputAttrs[1] += `required="${tcTriplePhone.required}"`;
								inputAttrs[2] += `required="${tcTriplePhone.required}"`;
								inputAttrs[3] += `required="${tcTriplePhone.required}"`;
							}
						}

						if (tcTriplePhone.readonly) {
							inputAttrs[1] += `readonly="${tcTriplePhone.readonly}" `;
							inputAttrs[2] += `readonly="${tcTriplePhone.readonly}" `;
							inputAttrs[3] += `readonly="${tcTriplePhone.readonly}" `;
						}

						const html =
							`<input id="${tcTriplePhone.id}-input" name="${tcTriplePhone.id}" ng-model="$phone.full" ng-pattern="${pattern}" type="hidden" ${inputAttrs[0]} />
							<div class="row flat">
								<div class="col-xs-3">
									<input id="${tcTriplePhone.id}-input-area" class="form-control ${inputClass}" name="${tcTriplePhone.id}_area" ng-disabled="$phone.isDisabled()" ng-model="$phone.area" type="text" ${inputAttrs[1]} />
								</div>
								<div class="col-xs-3">
									<input id="${tcTriplePhone.id}-input-prefix" class="form-control ${inputClass}" name="${tcTriplePhone.id}_prefix" ng-disabled="$phone.isDisabled()" ng-model="$phone.prefix" type="text" ${inputAttrs[2]} />
								</div>
								<div class="col-xs-6">
									<input id="${tcTriplePhone.id}-input-line" class="form-control ${inputClass}" name="${tcTriplePhone.id}_line" ng-disabled="$phone.isDisabled()" ng-model="$phone.line" type="text" ${inputAttrs[3]} />
								</div>
							</div>`;

						$element.html(html);
						$compile($element.contents() as any)($scope);

						tcTriplePhone.pattern = pattern;
					},
					restrict: 'E',
					require: ['tcTriplePhone', '?^tcForm'],
					scope: true
				};
			}
		]
	);
}